import ProjectSubheaderModal from "./components/ProjectSubheaderModal"
import { ITutor } from "../../interfaces"

export const ShowEntireTeamButton = ({ tutors }: { tutors: ITutor[] }) => {
    if (tutors.length > 1) return <ProjectSubheaderModal tutors={tutors} />
    return <></>
}